<style scoped>

.next-page-btns {
  flex-wrap: wrap;
  gap: 1rem;
}
</style>
<template>
  <register-container :step="step">
      <div class="card-body">
          <h1 class="head-title text-center font-weight-bold">
              Insurance Check
          </h1>
          <p class="text-center mb-4">Validate your Insurance details</p>

          <b-form
              @submit.prevent="formSubmitted"
              @keydown="form.onKeydown($event)"
          >
              <div
                  class="mt-4"
                  v-for="(insurance, idx) in form.insurances"
                  :key="'ins-' + idx"
                  style="position: relative"
              >
                  <SvgIcons
                      v-if="idx > 0 && insurance.insurance_status != 'verified'"
                      icon="insurance-document-close"
                      svgClass="ml-2"
                      style="margin-top: 2px; position: absolute; right: -27"
                      @click.native="deleteInsurance(insurance, idx);"
                  />
                  <b-row>
                      <b-col cols="12" sm="6" md="6" lg="6">
                          <b-form-group>
                              <template v-slot:label>
                                  Type of Insurance <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                  :disabled="insurance.insurance_status == 'verified'"
                                  v-model="insurance.insurance_type"
                                  :options="insuranceTypes"
                              ></b-form-select>
                              <div
                                  class="help-block invalid-feedback"
                                  v-if="insurance.error.errors.insurance_type"
                              >
                                  {{ insurance.error.errors.insurance_type[0] }}
                              </div>
                          </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6" md="6" lg="6">
                          <b-form-group>
                              <template v-slot:label>
                                  Policy Number <span class="text-danger">*</span>
                              </template>

                              <b-form-input
                                  :disabled="insurance.insurance_status == 'verified'"
                                  type="text"
                                  v-model="insurance.insurance_policy"
                                  v-bind:class="{
                              'is-invalid':
                                insurance.error.errors.insurance_policy,
                            }"
                              ></b-form-input>
                              <div
                                  class="help-block invalid-feedback"
                                  v-if="insurance.error.errors.insurance_policy"
                              >
                                  {{ insurance.error.errors.insurance_policy[0] }}
                              </div>
                          </b-form-group>
                      </b-col>
                  </b-row>

                  <b-row>
                      <b-col cols="12" sm="6" md="6" lg="6">
                          <b-form-group class="mr-3">
                              <template v-slot:label> Limit($) </template>
                              <b-form-input
                                  :disabled="insurance.insurance_status == 'verified'"
                                  type="text"
                                  v-model="insurance.insurance_limit"
                                  v-bind:class="{
                              'is-invalid':
                                insurance.error.errors.insurance_limit,
                            }"
                              ></b-form-input>
                              <div
                                  class="help-block invalid-feedback"
                                  v-if="insurance.error.errors.insurance_limit"
                              >
                                  {{ insurance.error.errors.insurance_limit[0] }}
                              </div>
                          </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6" md="6" lg="6">
                          <b-form-group>
                              <template v-slot:label> Expiry </template>
                              <date-picker
                                  :disabled="insurance.insurance_status == 'verified'"
                                  valueType="format"
                                  :format="'DD-MM-YYYY'"
                                  type="date"
                                  :hide-header="true"
                                  v-bind:min="minDate"
                                  v-model="insurance.insurance_expiry"
                                  v-bind:class="{
                              'is-invalid':
                                insurance.error.errors.insurance_expiry,
                            }"
                              ></date-picker>
                              <div
                                  class="help-block invalid-feedback"
                                  v-if="insurance.error.errors.insurance_expiry"
                              >
                                  {{ insurance.error.errors.insurance_expiry[0] }}
                              </div>
                          </b-form-group>
                      </b-col>
                  </b-row>

                  <b-form-group class="position-relative tobe">
                      <b-form-file
                          :disabled="insurance.insurance_status == 'verified'"
                          placeholder="Upload Documents"
                          multiple
                          @change="
                          attachInsuranceFiles(
                            $event,
                            insurance.insurance_files,
                            insurance.id
                          )
                        "
                          v-bind:class="{
                              'is-invalid': insurance.error.errors.insurance_files,
                            }"
                      >
                      </b-form-file>
                      <label class="upload-tab">
                          <SvgIcons
                              icon="upload-document-button"
                              width="25px"
                              height="20px"
                              svgClass="upload-docs"
                          />
                          <span class="upload-instruction">Allowed file types .pdf, .doc. Max file size 5 MB.</span>

                      </label>



                      <div style="margin-top: 10px;margin-bottom:10px">
                          <div
                              v-for="(error, idx) in insurance.error.errors" :key="idx"
                          >
                      <span class="help-block invalid-feedback"
                            v-if="idx.startsWith('insurance_files')">
                            {{error[0]}}
                        </span>
                          </div>
                      </div>

                  </b-form-group>
                  <b-row>
                      <div
                          class="up-box d-flex mr-2 ml-2"
                          v-for="(file, idx2) in insurance.insurance_files"
                          :key="'ins-file' + idx + '-' + idx2"
                      >
                          <a :href="file.signed_url" target="_blank"><p>{{ file.name }}</p></a>
                          <!-- <p>{{ file.name }}</p> -->
                          <SvgIcons
                              v-if="insurance.insurance_status != 'verified'"
                              icon="insurance-document-close"
                              svgClass="ml-2"
                              style="margin-top: 2px"
                              @click.native="
                            removeInsuranceMedia(file);
                            insurance.insurance_files.splice(
                              insurance.insurance_files.indexOf(file),
                              1
                            );
                          "
                          />
                      </div>
                  </b-row>
                  <hr
                      class="mb-3"
                      v-if="idx != form.insurances.length - 1"
                  />

              </div>
              <hr class="mb-3" />
              <!-- <a href="#!" @click.prevent="addNewInsurance" style="color: #000;">+ Add More</a><br/><br/> -->
              <b-button
                  type="button"
                  variant="outline-primary"
                  class="add-insurance-btn mb-4"
                  @click.prevent="addNewInsurance"
              >Add Another Insurance</b-button
              >

              <div class="next-page-btns d-flex justify-content-between pt-3">
                  <b-button
                      class="back-btn"
                      :disabled="form.busy"
                      type="button"
                      variant="outline-primary"
                      @click="$router.go(-1)"
                  >Back
                  </b-button>

                  <b-button
                      :disabled="form.busy"
                      type="submit"
                      variant="primary"
                      class="btn-grad"
                  >Next
                  </b-button>
              </div>
          </b-form>
      </div>
  </register-container>
</template>

<script>
import { Form, HasError } from "vform";
import _ from "lodash";
import SideBar from "../includes/SideBar.vue";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import RegisterContainer from "./RegisterContainer.vue";
Vue.component(HasError.name, HasError);

export default {
  props: ["step", "sidebarListLinks"],
  components: {
      RegisterContainer,
    FooterComponent,
    SideBar,
    SvgIcons,
  },

  data() {
    return {
      minDate: "",
      form: new Form({
        insurances: [],
      }),
      insuranceTypes: [
        { value: "", text: "Choose", disabled: true },
        { value: "public-liability", text: "Public Liability" },
        { value: "workers-compensation", text: "Workers Compensation" },
        { value: "professional-indemnity", text: "Professional Indemnity" },
        { value: "other-insurances", text: "Other Insurances" },
      ],
    };
  },
  mounted() {
    this.fetchFormData();
    this.minExpiryDate();
    // this.insertNullRowForFileUpload()
  },
  methods: {
    fetchFormData() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/insurance/getDetails", {
          load_insurances_media: 1,
        })
        .then((response) => {
          if (response.data.insurances == "empty") {
            //Redirecting into business page if business is not created
            this.$router.push({
              name: "register-contractor",
              params: { step: 2 },
            });
          } else {
              if (response.data.insurances.length) {
              this.form.insurances = [];
              response.data.insurances.forEach((insurance) => {
                this.form.insurances.push({
                  id: insurance.id ? insurance.id : "",
                  insurance_type: insurance.insurance_type ? insurance.insurance_type : "",
                  insurance_policy: insurance.insurance_policy ? insurance.insurance_policy : "",
                  insurance_limit: insurance.insurance_limit ? insurance.insurance_limit : "",
                  insurance_expiry: insurance.insurance_expiry ?  moment(insurance.insurance_expiry).format("DD-MM-YYYY") : "",
                  insurance_files: insurance.media ? insurance.media : [],
                  insurance_status: insurance.insurance_status,
                  error: {
                    errors: {},
                  },
                });
              });
            } else {
              this.addNewInsurance();
            }
          }
          this.$root.$data.bsLoader = false;
        }).catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },

    async formSubmitted() {

      var orderPromises = this.form.insurances.map((insurance, index) => {
        this.$root.$data.bsLoader = true;
        return new Promise((resolve, reject) => {
          var data = new FormData();
          data.append("id", insurance.id ? insurance.id : "");
          data.append("insurance_type", insurance.insurance_type ? insurance.insurance_type : "");
          data.append("insurance_policy", insurance.insurance_policy ? insurance.insurance_policy : "");
          data.append("insurance_limit", insurance.insurance_limit ? insurance.insurance_limit : "");
          data.append("insurance_expiry", insurance.insurance_expiry ? insurance.insurance_expiry : "");

          for (var i = 0; i < insurance.insurance_files.length; i++) {
            if(insurance.insurance_files[i] instanceof File ){
              data.append("insurance_files[]", insurance.insurance_files[i]);
            }else{
               data.append("previous_insurance_files[]", insurance.insurance_files[i]);
            }
          }

          return axios
            .post("api/contractor/insurance/updateOrCreate2", data, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              this.form.insurances[index].error.errors = {};
              resolve(insurance)
            })
            .catch((error) => {
              this.form.errors = error.response.data;
              if (error.response?.data?.errors) {
                this.form.insurances[index].error =
                  error.response.data;
              }
              resolve(insurance)
            });

        },Math.random()*2000)
        });

      Promise.all(orderPromises).then((results) => {
        if (!Object.keys(this.form.errors.errors).length > 0) {
          this.$router.push({
            name: "register-contractor",
            params: { step: 5 },
          });
        // this.$root.$data.bsLoader = false;
        }
      });
    },

    addNewInsurance() {
    this.$root.$data.bsLoader = true;
    this.form.insurances.push({
      id: "",
      insurance_type: "",
      insurance_policy: "",
      insurance_limit: "",
      insurance_expiry: "",
      insurance_files: [],
      error: {
        errors: {},
      },
    });
    this.$root.$data.bsLoader = false;

    // insuranceLimit() {
    //     this.componentForm.insurance_limit.replace(/\D/g, "");
    //   this.componentForm.insurance_limit =
    //     this.componentForm.insurance_limit
    //       .replace(/\D/g, "")
    //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // },
  },

    attachInsuranceFiles: function (event, attachFilesTo, insurance_id) {
      this.$root.$data.bsLoader = true;
      if (!event.target.files.length) return;
      var input = event.target.files;
      input &&
        _.forEach(input, (file) => {
          attachFilesTo.push(file);
        });
        this.$root.$data.bsLoader = false;
    },

    //For Saving file directly to s3 in onchange
    // attachInsuranceFiles: function (event, attachFilesTo, insurance_id) {
    //   if (!event.target.files.length) return;
    //   var input = event.target.files;
    //   input &&
    //     _.forEach(input, (file) => {
    //       const formData = new FormData(); //For uploading in storage
    //       formData.append("upload", file);
    //       formData.append("insurance_id", insurance_id);

    //       axios
    //         .post("api/contractor/insurance/addMedia", formData, {
    //           headers: { "Content-Type": "multipart/form-data" },
    //         })
    //         .then((response) => {
    //           var extension = file.name.split(".").pop();
    //           attachFilesTo.push({
    //             extension: extension,
    //             name: file.name,
    //             uuid: response.data.uuid,
    //           });
    //         });
    //     });
    // },

    // deleteInsurance(insurance) {
    //   this.$root.$data.bsLoader = true;
    //   axios
    //     .post("api/contractor/insurance/deleteInsurance", {
    //       insurance_id: insurance.id,
    //     })
    //     .then((response) => {});
    //     this.form.insurances.splice(this.form.insurances.indexOf(insurance), 1);
    //     this.$root.$data.bsLoader = false;
    // },

    removeMedia(file) {
      if(file.uuid) {
        this.$root.$data.bsLoader = true;
        axios
          .post("api/contractor/insurance/deleteMedia", { file: file.uuid })
          .then((response) => {
            this.$root.$data.bsLoader = false;
          }).catch((err) => {
            this.$root.$data.bsLoader = false;
          });
      }
    },

    minExpiryDate() {
      var date = new Date();
      var dd = date.getDate() + 1;
      var mm = date.getMonth() + 1; //January is 0!
      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var today = yyyy + "-" + mm + "-" + dd;
      this.minDate = today;
    },

  removeInsuranceMedia(file) {
    if (file.uuid) {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/insurance/deleteMedia", { file: file.uuid })
        .then((response) => {
          Swal.fire({
            title: "File Deleted Successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
          this.$root.$data.bsLoader = false;
        }).catch((err) => {
           this.$root.$data.bsLoader = false;
        });
    }
  },

    deleteInsurance(insurance, idx) {
      if(insurance.id){
        this.$root.$data.bsLoader = true;
        axios
        .post("api/contractor/insurance/deleteInsurance", {
          insurance_id: insurance.id,
        })
        .then((response) => {
          this.form.insurances.splice(
            this.form.insurances.indexOf(insurance),1);
            Swal.fire({
              title: "Insurance Deleted Successfully.",
              icon: "success",
              timer: 3000,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
            });
          this.$root.$data.bsLoader = false;
        }).catch((err) => {
          this.$root.$data.bsLoader = false;
        });
      } else{
        this.form.insurances.splice(idx,1);
        this.$root.$data.bsLoader = false;
      }
    },

    // insertNullRowForFileUpload(){
    //     axios.post('/api/contractor/insurance/addNullRow').then((response) => {
    //         console.log(response.data.insuranceDetails);
    //         return

    //     })
    // }
  },
};
</script>
